import React from 'react';
import { SessionComplianceChecklistItem } from './Hooks/useSessionCompliance/type';

export const SessionComplianceContext = React.createContext<SessionComplianceChecklistItem[] | null>(null);

export default function useSessionComplianceContext() {
  const context = React.useContext(SessionComplianceContext);

  if (!context) {
    throw new Error('useSessionComplianceContext must be used within a SessionComplianceContextProvider');
  }

  return context;
}
